/**
 * ISHVARI WEBSITE V3 — HOMEPAGE HERO SYSTEM
 * ---------------------------------------------------------------------
 * Deliberately minimal. Scroll-reveal for [data-animate] elements is
 * already handled sitewide by assets/global.js (Global Foundation) —
 * it is NOT reimplemented here.
 *
 * The only Hero-specific behavior is the optional background video:
 *   - Never autoplays for visitors who prefer reduced motion (the
 *     static background image underneath is the entire experience).
 *   - Pauses when the tab/section is not visible, to avoid wasting
 *     battery/bandwidth on a video nobody is looking at.
 *   - Fades in only once it can actually play, so there is never a
 *     flash of an unstyled/black video element.
 * ===================================================================== */

(function () {
  "use strict";

  var hero = document.querySelector(".hero");
  if (!hero) return;

  var video = hero.querySelector(".hero__video");
  if (!video) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduceMotion) {
    // Respect the user's preference outright — do not load/play video.
    video.removeAttribute("autoplay");
    video.pause && video.pause();
    return;
  }

  function markReady() {
    video.classList.add("is-ready");
  }

  if (video.readyState >= 2) {
    markReady();
  } else {
    video.addEventListener("loadeddata", markReady, { once: true });
  }

  // Pause/resume based on visibility to save resources when the Hero
  // has scrolled out of view or the tab is backgrounded.
  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play && video.play().catch(function () {
              /* Autoplay can be blocked by the browser — the static
                 background image remains visible underneath, so this
                 is a silent, harmless no-op. */
            });
          } else {
            video.pause && video.pause();
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(hero);
  }

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      video.pause && video.pause();
    } else if (hero.getBoundingClientRect().top < window.innerHeight) {
      video.play && video.play().catch(function () {});
    }
  });
})();
